var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, InputNumber, Select } from '@robinpowered/ui-kit';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
export var TimeInput = function (_a) {
    var onChange = _a.onChange, initialValue = _a.initialValue, maxHour = _a.maxHour, maxMinutes = _a.maxMinutes, error = _a.error, disabled = _a.disabled;
    var t = useTranslation('meetingRooms').t;
    var _b = __read(useState('minutes'), 2), timeType = _b[0], setTimeType = _b[1];
    var _c = __read(useState(initialValue), 2), timeValue = _c[0], setTimeValue = _c[1];
    var maxInput = timeType === 'minutes' ? maxMinutes : maxHour;
    var selectAfter = useMemo(function () {
        return (_jsx(Flex, { style: {
                width: '100%',
            }, children: _jsx(Select, { defaultValue: timeType, popupMatchSelectWidth: false, value: timeType, disabled: disabled, status: error ? 'error' : undefined, "aria-label": timeType === 'minutes' ? t('buffers.min') : t('buffers.hours'), options: [
                    {
                        label: t('buffers.min'),
                        value: 'minutes',
                        'aria-label': t('buffers.min'),
                    },
                    {
                        label: t('buffers.hours'),
                        value: 'hours',
                        'aria-label': t('buffers.hours'),
                    },
                ], onSelect: function (value) {
                    var newMax = value === 'minutes' ? maxMinutes : maxHour;
                    var clampedValue = Math.min(timeValue, newMax);
                    setTimeType(value);
                    setTimeValue(clampedValue);
                    onChange(clampedValue, value);
                } }) }));
    }, [timeType, onChange, t, timeValue, disabled, error, maxMinutes, maxHour]);
    return (_jsx(InputWrapper, { children: _jsx(InputNumber, { addonAfter: selectAfter, disabled: disabled, "aria-valuetext": "".concat(timeValue, " ").concat(timeType === 'minutes' ? t('buffers.min') : t('buffers.hours')), value: timeValue, onChange: function (e) {
                if (e === null || e === undefined)
                    return;
                setTimeValue(e);
                onChange(e, timeType);
            }, min: 0, max: maxInput, status: error ? 'error' : undefined }) }));
};
// Suppress the red text color that antd applies with status="error" — only the
// border outline should indicate the error state, not the input text.
var InputWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  .ant-input-number-group-wrapper,\n  .ant-input-number {\n    width: 100%;\n  }\n\n  .ant-input-number-group-wrapper-status-error .ant-input-number-input,\n  .ant-input-number-status-error .ant-input-number-input {\n    color: inherit;\n  }\n"], ["\n  width: 100%;\n\n  .ant-input-number-group-wrapper,\n  .ant-input-number {\n    width: 100%;\n  }\n\n  .ant-input-number-group-wrapper-status-error .ant-input-number-input,\n  .ant-input-number-status-error .ant-input-number-input {\n    color: inherit;\n  }\n"])));
var templateObject_1;
